/**
 * Demonstration data — wipe the program hierarchy and re-seed the client
 * document's examples (28 Aug 2026).
 *
 * ADMIN only, and only where the installation has enabled it. `getDemoDataStatus`
 * exists so the portal can find out which, and draw nothing where the answer is
 * no — a button that can only ever return 403 is worse than no button.
 */

import { apiGet, apiPost } from './client';

/** Row counts either side of a reset. Every number is a whole-table count. */
export interface DemoDataCounts {
  programs: number;
  activities: number;
  sessions: number;
  attendance: number;
  assignments: number;
}

export interface DemoDataResetResult {
  before: DemoDataCounts;
  after: DemoDataCounts;
}

export interface DemoDataStatus {
  reset_available: boolean;
}

export function getDemoDataStatus(): Promise<DemoDataStatus> {
  return apiGet<DemoDataStatus>('/maintenance/demo-data');
}

export function resetDemoData(): Promise<DemoDataResetResult> {
  return apiPost<DemoDataResetResult>('/maintenance/demo-data/reset', {});
}
